// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notifications_wrapper__nZDFL","card":"Notifications_card__yIYHf","notification":"Notifications_notification__aj9rx","content":"Notifications_content__t_ThD"};